// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easy-commerce-block-wrapper {
    width: 100%;
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./blocks/single-product/title/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".easy-commerce-block-wrapper {\n    width: 100%;\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
